<template>
    <div class="error-page d-flex flex-wrap align-content-center justify-content-center">
        <h1 class="d-flex text-center w-100 justify-content-center">
            {{ title }}
        </h1>

        <div v-if="description" class="d-flex text-center w-100 justify-content-center content-text">
            <p>
                {{ description }}
            </p>
        </div>

        <div class="d-flex w-100 justify-content-center">
            <a :href="customErrorPageButtonLink" class="btn button homepage-button">{{ customErrorPageButtonText }}</a>
        </div>

        <div class="oval"></div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default {
    setup() {
        const store = useStore()
        const route = useRoute()

        return {
            store,
            route,
        }
    },
    unmounted() {
        this.store.state.global.data.errorPage = {}
        this.store.state.global.data.showErrorPage = false
    },
    computed: {
        title: function () {
            return this.store.state.global.data.errorPage.title || this.route.meta.title
        },
        description: function () {
            return this.store.state.global.data.errorPage.description || this.route.meta.description || null
        },
        customErrorPageButtonLink: function () {
            if (this.store.state.global.page && this.store.state.global.page.custom_error_button_link) {
                return this.store.state.global.page.custom_error_button_link
            } else {
                return '/'
            }
        },
        customErrorPageButtonText: function () {
            if (this.store.state.global.page && this.store.state.global.page.custom_error_button_text) {
                return this.store.state.global.page.custom_error_button_text
            } else {
                return 'Back to homepage'
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.error-page {
    background-color: var(--results-hero-banner-background);
    height: calc(100vh - 56px);
    padding: 0 15px;
    text-align: center;

    @media screen and (min-width: $bp-medium) {
        height: calc(100vh - 96px);
    }

    h1 {
        color: var(--hero-offer-color);
        font-family: var(--heading-font);
        font-size: rem(73px);
        font-weight: 700;
        margin: 0 auto;
    }

    .homepage-button {
        background-color: var(--result-search-button-background);
        line-height: 40px;
        margin-bottom: 64px;
        max-width: 190px;

        &:hover {
            background-color: var(--result-search-button-hover-background);
        }
    }

    .oval {
        background: var(--preloader-background-color);
        border-radius: 50%;
        filter: brightness(85%);
        height: 23px;
        max-width: 760px;
        width: 100%;
    }

    .content-text {
        p {
            color: var(--hero-offer-color);
            font-family: var(--primary-font);
            font-size: rem(30px);
            font-weight: 400;
            margin-bottom: 50px;
        }
    }
}
</style>
